import { render, staticRenderFns } from "./TableContentCrewList.vue?vue&type=template&id=0a10f2eb&"
import script from "./TableContentCrewList.vue?vue&type=script&lang=js&"
export * from "./TableContentCrewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports